<ion-header>
  <ion-toolbar color="medium">
    <ion-buttons slot="start">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{titulo}}</ion-title>
    @if (edit) {
      <ion-buttons slot="end">
        <ion-button (click)="eliminarFoto()" [disabled]="data === ''">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button>
        <ion-button (click)="save()" [disabled]="imagen === ''">
          <ion-icon slot="icon-only" name="checkmark-circle"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
<ion-content>
  @if (edit) {
    @if (imageChangedEvent) {
      <div class="kblab-flex kblab-flex-dir-r ion-justify-content-center ion-align-items-center point">
        <img [lazyLoad]="data || SINFOTO" [defaultImage]="shared.LOADER" (click)="elegirFoto()" alt="imagen">
      </div>
    } @else {
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        output="base64"
        format="png"
        (imageCropped)="image($event)"
      ></image-cropper>
    }
    <input class="ion-hide" type="file" accept="image/*" #camera (change)="resize($event)">
  } @else {
    <div class="kblab-flex kblab-flex-dir-r ion-justify-content-center ion-align-items-center point">
      <img [lazyLoad]="data" [defaultImage]="shared.LOADER" alt="imagen">
    </div>
  }
</ion-content>
